module.exports = __webpack_public_path__ + "std/img/raffle-logo.c234abc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/raffle-logo.webp
// module id = W1pE
// module chunks = 0 6